import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { SpecialFormControl } from "@utilities/SpecialForms";
import { Observable, BehaviorSubject, combineLatest } from "rxjs";
import {
  filter,
  startWith,
  map,
  take,
  tap,
  distinctUntilChanged,
} from "rxjs/operators";
import { isNullOrUndefined } from "util";
import { FormControl, Validators } from "@angular/forms";
import { Subscription } from "rxjs";
import { AdFacadeService } from "@services/active-directory/ad-facade.service";
import { UserGraphApiModel } from "@models/user.model";
import { Validations } from "@utilities/validations.customer";

@Component({
  selector: "control-autocomplete-local",
  templateUrl: "./control-autocomplete-local.component.html",
  styleUrls: ["./control-autocomplete-local.component.scss"],
})
export class ControlAutocompleteLocalComponent implements OnInit {
  @Input() sfcontrol: SpecialFormControl;

  @Output("word") word: EventEmitter<any> = new EventEmitter();
  @Output("blurAction") _blurAction: EventEmitter<any> = new EventEmitter();
  @Output("enterKey") _enterKey: EventEmitter<any> = new EventEmitter();

  public typeField: string = "control-read-only";

  public inputCtrl = new FormControl();

  public dataList$: Observable<Object[]>;

  private _currentValue = new BehaviorSubject<any>(null);

  private _listAll$ = new BehaviorSubject<Object[]>([]);
  subs = new Subscription();
  filteredOptions: string[] = [];

  constructor(private _adFacadeService: AdFacadeService) {}

  ngOnInit() {
    /* this.subs.add(
        this.data.subscribe((data) => {
          this.filteredOptions = data;
        })
      )
     */

    /* if (this.sfcontrol.data[0] instanceof Observable) {
      this.sfcontrol.data[0]
        .pipe(
          filter( i => !isNullOrUndefined(i) ) 
        ).subscribe( i => this._listAll$.next( i ) )
    } else {
      this._listAll$.next( this.sfcontrol.data[0] )
    } */

    this._adFacadeService
      .getADUsers$()
      .pipe(
        //tap((x) => console.log("NUEVOS AD", x)),
        filter((i) => !isNullOrUndefined(i) && i.length > 0),
        map((entrada) => {
          let i = [...entrada];
          return i.sort((a, b) => this.sortData(a, b));
        }),
        //tap((x) => console.log("NUEVOS AD", x))
      )
      .subscribe((i) => this._listAll$.next(i));

    const input$ = this.inputCtrl.valueChanges.pipe(
      filter((i) => !isNullOrUndefined(i)),
      startWith(""),
      map((i) => (<string>i).toLowerCase()),
      tap((i) => {
        this.words(i);
      })
    );

    this.dataList$ = combineLatest(this._listAll$, input$).pipe(
      /* tap(alert), */
      map(([list, textInput]) => {
        let _list = [...list];
        return _list.filter((i) =>
          (<string>i[this.sfcontrol.data[2]]).toLowerCase().includes(textInput)
        );
      })
    );

    combineLatest(this._currentValue, this._listAll$)
      .pipe(
        //tap((x) => console.log("combineLatest antes filter", x)),
        filter(([currentValue, list]) => !isNullOrUndefined(currentValue)),
        //tap((x) => console.log("combineLatest despues filter", x)),
        map(([currentValue, list]) => {
          //console.log(list, this.sfcontrol.data[1], currentValue);
          let find = list.find(
            (i) => i[this.sfcontrol.data[1]] === currentValue
          );
          find = find ? find : null;
          return find;
        }),
        //tap((x) => console.log("combineLatest despues map", x)),
        filter((i) => !isNullOrUndefined(i)),
        distinctUntilChanged((data1, data2) => data1["mail"] == data2["mail"]),
        //tap((x) => console.log("combineLatest despues distinctUntilChanged", x))
        //take(1)
      )
      .subscribe((i) => {
        console.log(i[this.sfcontrol.data[2]])
        this.inputCtrl.setValue(i[this.sfcontrol.data[2]])
      });

    // ACTUALIZACION BASADO EN CAMBIO DE VALOR DEL CONTROL
    this.sfcontrol.valueChanges.subscribe((value) => {
      //console.log(value);
      //console.log(this.sfcontrol)
      if(this.sfcontrol.readOnly){
        this.inputCtrl.disable()
      }else{
        this.inputCtrl.enable()
      }
      let valid = JSON.parse(localStorage.getItem("validEmailArea"));
      //console.log(valid)
      let message: any;
      if (valid) {
        message = { repeatedName: "El usuario ya tiene esta área asignada" };
        Validations.addValidationsAutoComplete(this.inputCtrl, message);
        this.inputCtrl.markAsTouched();
        this.inputCtrl.updateValueAndValidity();
      } else {
        this.inputCtrl.setErrors(null);
        this.inputCtrl.setValidators(null);
        this.inputCtrl.markAsTouched();
        this.inputCtrl.updateValueAndValidity();
      }
      //console.log(this.inputCtrl)
      if (value) {
        this._currentValue.next(value);
      } else {
        this.inputCtrl.setValue(null);
        this.inputCtrl.setErrors(null);
        this.inputCtrl.setValidators(null);
        this.inputCtrl.markAsTouched();
        this.inputCtrl.updateValueAndValidity();
      }
    });
  }

  words(i) {
    //console.log("PALABRA", i);
    this.word.emit(i);
    if (i) {
      this._adFacadeService.searchAllADUsers(i);
    }
    //alert(i)
  }

  private sortData(a: UserGraphApiModel, b: UserGraphApiModel): number {
    const aName = a.displayName ? a.displayName.toLowerCase() : "";
    const bName = b.displayName ? b.displayName.toLowerCase() : "";
    let response: number;
    if (aName > bName) {
      response = 1;
    }
    if (aName < bName) {
      response = -1;
    }
    if (aName === bName) {
      response = 0;
    }
    return response;
  }
  /* update(input$){
    this.dataList$ = combineLatest( this._listAll$, input$ )
        .pipe(
          map( ([list, textInput]) => {
              let _list = [...list];
              return _list.filter( i => (<string>i[ this.sfcontrol.data[2] ]).toLowerCase().includes( textInput ) );
            }
          ),
        );
  } */

  public selected(element: object): void {
    this.sfcontrol.markAsDirty();
    this.sfcontrol.setValue(element[this.sfcontrol.data[1]]);
    this.sfcontrol.setComplement(element);
  }
}
